import { Paper } from "@material-ui/core";
import {
  StyleRulesCallback,
  WithStyles,
  withStyles
} from "@material-ui/core/styles";
import * as React from "react";
import * as Autosuggest from "react-autosuggest";
import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

import PlacesAutoCompeteInput from "./PlacesAutoCompleteInput";
import PlacesAutoCompleteListItem from "./PlacesAutoCompleteListItem";

interface IProps {
  autoComplete: IGooglePlace[];
  className?: string;
  onPlaceSelected: (place: IGooglePlace) => void;
  onFreeTextSelected: (place: string) => void;
  onFetchRequested: (query: string) => void;
  searchQuery: string;
  onChange: (query: string) => void;
  autoFocus?: boolean
  navigationProperty?: string;
  inputLabel: string,
  placeHolder: string,
  onClearRequested: () => void;
}

const styles: StyleRulesCallback = ({ palette, spacing, breakpoints }) => ({
  suggestionsContainerOpen: {
    position: "absolute",
    boxShadow: "0 2px 4px 0 rgba(226, 230, 236, 0.5)",
    zIndex: 1,
    backgroundColor: palette.common.white,
    maxHeight: "15em",
    width: "100%",
    marginLeft: "0",
    overflowY: "scroll",
    fontSize: "13px!important",
    [breakpoints.down("sm")]: {
      position: "absolute",
      left: "0%",
      overflowY: "inherit",
      maxHeight: "inherit",
      width: "100%"
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: "white"
    }
  },
  container: {
    position: "relative",
    width: "100%",
    '@media screen and (orientation: landscape)': {
      marginTop: 0,
    }
  },
  suggestion: {
    fontSize: "13px!important",
    display: "block",
    "&:hover": {
      backgroundColor: "transparent!important"
    }
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
    [breakpoints.down("sm")]: {
      paddingLeft: "1em"
    }
  },
});

@(withStyles(styles) as any)
export default class PlacesAutoComplete extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
  public render() {
    const {
      autoComplete,
      classes,
      searchQuery,
        placeHolder,
      onClearRequested
    } = this.props;
    return (
          <Autosuggest
              theme={{
                container: classes!.container,
                suggestionsContainerOpen: classes!.suggestionsContainerOpen,
                suggestionsList: classes!.suggestionsList,
                suggestion: classes!.suggestion
              }}
              suggestions={autoComplete}
              onSuggestionsClearRequested={onClearRequested}
              onSuggestionsFetchRequested={this.onFetchRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderItem}
              renderSuggestionsContainer={this.renderSuggestionsContainer}
              renderInputComponent={this.renderInput}
              inputProps={{
                classes,
                placeholder: placeHolder,
                value: searchQuery,
                onChange: this.onChange,
                onKeyPress: this.onKeyPress
              }}
          />
    );
  }

  private onFetchRequested: Autosuggest.SuggestionsFetchRequested = props => {
    const { onFetchRequested } = this.props;
    const { value } = props;
    onFetchRequested(value);
  };

  private renderInput = (props: Autosuggest.InputProps<IGooglePlace>) => {
    const { classes,navigationProperty , ...other } = props;
    const { searchQuery, autoFocus } = this.props;
    return (
        <PlacesAutoCompeteInput
            inputLabel={this.props.inputLabel}
            sendEnabled={searchQuery.length > 0}
            navigationProperty = {this.props.navigationProperty}
            onSendClicked={this.onSendClicked}
            autoFocus={autoFocus}
            InputProps={{
              classes: {
                input: classes.input
              },
              ...(other as any)
            }}
        />
    );
  };

  private renderSuggestionsContainer = (
      props: Autosuggest.RenderSuggestionsContainerParams
  ) => {
    const { children, containerProps } = props;
    return (
        <Paper square={true} {...containerProps}>
          {children}
        </Paper>
    );
  };

  private onKeyPress = (event: any) => {
    const { autoComplete, searchQuery, onPlaceSelected } = this.props;
    if (event.key === "Enter") {
      const selection = autoComplete.find(item => item.name === searchQuery);
      if (selection) {
        onPlaceSelected(selection);
      } else {
        this.onSendClicked();
      }
    }
  };

  private onSendClicked = () => {
    const { onFreeTextSelected, searchQuery } = this.props;
    onFreeTextSelected(searchQuery);
  };

  private onChange = (
      event: React.FormEvent<any>,
      params?: Autosuggest.ChangeEvent
  ) => {
    const { onChange, onPlaceSelected, autoComplete } = this.props;
    const { method, newValue } = params!;
    onChange(newValue);
    if (method === "enter") {
      const selection = autoComplete.find(place => place.name === newValue);
      onPlaceSelected(selection!);
    }
  };

  // This will also change how coworking search is displayed to the user, this is done for the SBA loan process
  // private getSuggestionValue = (place: IGooglePlace) => place.name;
  private getSuggestionValue = (place: IGooglePlace) => place.formattedAddress;

  private renderItem: Autosuggest.RenderSuggestion<IGooglePlace> = (
      place,
      props
  ) => {
    const { onPlaceSelected } = this.props;

    return (
        <PlacesAutoCompleteListItem
            place={place}
            key={place.id}
            onPlaceSelected={onPlaceSelected}
            selected={props.isHighlighted}
        />
    );
  };
}



// WEBPACK FOOTER //
// ./src/scenes/Bots/Common/PlacesAutoComplete/PlacesAutoComplete.tsx